import { WizardTranslations } from "./wizard-pt-br";

export const WIZARD_FR_FR: WizardTranslations = {
	common: {
		pointsOfSale: "Points de vente",
		saved: "Enregistrer",
		cancel: "Annuler",
		typeHere: "Entrez ici",
		close: "Fermer",
	},
	welcome: {
		title: "Bienvenue, <placeName>{{placeName}}</placeName> !",
		subtitle: "Choisissez comment vous voulez configurer votre opération.",
		skipButton: "Je ne veux pas configurer maintenant",
		placeIdNotFound: "ID de lieu non trouvé",
		features: {
			preConfiguredSteps: "Étapes avec suggestions préconfigurées",
			guidedStepsWithAI: "Étape par étape guidé avec l'aide de l'IA",
			advancedConfigurations: "Configurations avancées et personnalisations",
			complexFeatures: "Fonctionnalités plus complexes",
		},
		guidedMode: {
			title: "Création guidée (mode simplifié)",
			subtitle: "Nous vous guidons étape par étape",
			buttonText: "Accéder au mode simplifié",
			features: {
				basicConfigurations: "Configurations plus basiques",
				idealForSimpleOperations:
					"Idéal pour les opérations plus simples et plus petites",
			},
		},
		advancedMode: {
			title: "Création avancée",
			subtitle: "Plus d'options et détails de configuration",
			buttonText: "Accéder au mode avancé",
			features: {
				directConfiguration: "Configuration directe dans les modules du Dashboard",
				idealForComplexOperations: "Idéal pour les opérations grandes et complexes",
			},
		},
	},
	container: {
		stepIndexTitle: "Configurez votre lieu",
		buttons: {
			back: "Retour",
			close: "Fermer",
			next: "Suivant",
			configureLater: "Configurer plus tard",
			finishConfiguration: "Terminer la configuration",
			backToStep: "Retour à l'étape {{step}}",
		},
		finishConfirmation: {
			title: "Terminer la configuration de l'opération",
			descriptionPart1:
				"Vous êtes sur le point de terminer la configuration de cette opération.",
			descriptionPart2:
				"Un résumé final sera généré et sera disponible pour consultation à tout moment. Ensuite, vous pourrez réviser et modifier si nécessaire.",
			cancelButton: "Annuler",
			confirmButton: "Terminer la configuration",
			successMessage: "Configuration enregistrée avec succès !",
			continueToNextStep: {
				title: "Terminer et passer à l'étape suivante",
				descriptionPart1: "Vous êtes sur le point de terminer cette étape.",
				descriptionPart2:
					"En continuant, les paramètres seront enregistrés et vous passerez à l'étape suivante.",
				confirmButton: "Enregistrer et continuer",
			},
		},
		closeModalConfirmation: {
			title: "Quitter la configuration sans enregistrer ?",
			description:
				"En fermant maintenant, les informations configurées jusqu'à présent ne seront pas enregistrées et vous perdrez la progression. Souhaitez-vous continuer ?",
			cancelButton: "Continuer la configuration",
			confirmButton: "Quitter sans enregistrer",
			fromSecondStep: {
				title: "Quitter la configuration simplifiée ?",
				descriptionIntro:
					"Cet assistant vous aide à configurer votre opération de manière simplifiée. Si vous partez maintenant :",
				bullet1: "Vous ne pourrez pas revenir pour continuer la configuration ici",
				bullet2: "Les informations de cette étape seront supprimées",
				bullet3: "Les étapes déjà terminées resteront enregistrées",
				descriptionOutro:
					"En partant maintenant, les prochaines configurations devront être faites directement dans les écrans avancés du Tableau de bord.",
				cancelButton: "Continuer la configuration",
				confirmButton: "Quitter la configuration simplifiée",
			},
		},
		steps: {
			basicInformation: {
				title: "Informations de base",
				subtitle: "Configurez le type d'opération",
				operationType: {
					title: "Comment les clients <highlight>achèteront</highlight>-ils ?",
					subtitle:
						"Choisissez un ou plusieurs formats qui s'appliqueront à cette opération.",
					alert: {
						message:
							"Ces options sont déjà cochées d'après le contrat de votre opération.",
						description:
							"Vous pouvez les conserver telles quelles ou les ajuster si vous le souhaitez.",
					},
					subStepTitle: "Type d'opération",
				},
				functionalities: {
					title:
						"Quelles seront les <highlight>fonctionnalités</highlight> de cette opération ?",
					subtitle:
						"Les fonctionnalités sont des options avec des ressources qui permettent de configurer l'opération de manière personnalisée.",
					subStepTitle: "Fonctionnalités",
					searchFunctionalities: "Rechercher par fonctionnalité",
					placeholderSearchFunctionalities: "Entrez ici la fonctionnalité",
					activeLabel: "actives",
					loadingText: "Chargement des fonctionnalités...",
					emptySearchResults: "Aucune fonctionnalité trouvée",
				},
				review: {
					title:
						"Nous avons déjà compris les <highlight>configurations initiales</highlight> de l'opération !",
					subtitle: "Selon vos réponses, le système configurera :",
					subStepTitle: "Révision",
					reviewTitle: "Réviser les réponses",
					reviewSubtitle:
						"Vous pourrez les modifier maintenant, avant de terminer l'étape.",
					editStep: "Modifier l'étape",
					operationTypeLabel: "Type d'opération",
					functionalitiesLabel: "Fonctionnalités",
					notInformed: "Non renseigné",
					selectedCount: "{{count}} sélectionné(s)",
					viewFunctionalities: "Voir les fonctionnalités",
				},
			},
			pointsOfSale: {
				pdvCentralName: "Point de vente central",
				title: "Points de vente",
				subtitle: "Configurez les emplacements de vente",
				pointsOfSale: {
					subStepTitle: "Points de vente",
					title: "Quels seront les points de vente de cette opération ?",
					subtitle:
						"Nommez uniquement les points de vente qui seront les emplacements où seront placées les machines Zig.",
					createButton: "Créer un point de vente",
					defaultPdvName: "Nouveau point de vente",
					totalCount: "Total de	points de vente: <strong> {{count}} </strong>",
					aiTutorial: "Découvrez comment utiliser l'IA pour créer des points de vente",
					emptyTitle: "Aucun point de vente pour l'instant",
					emptySubtitle: "Créez votre premier point de vente pour commencer.",
					tour: {
						step1: {
							title:
								"Le point de vente est l'endroit où se déroulent les ventes de votre opération via les machines Zig.",
							content:
								"Si votre opération n'a qu'un seul point de vente, continuez simplement. Si vous devez modifier ou créer de nouveaux points, vous pouvez le faire maintenant.",
						},
						step2: {
							title: "Vous pouvez créer les points de vente avec l'aide de l'IA",
							content:
								"Si vous souhaitez utiliser l'IA, décrivez les noms et quantités souhaitées, et ils seront générés automatiquement.",
						},
						step3: {
							title:
								"Vous voulez réviser quelque chose ? Utilisez le menu latéral pour revenir aux étapes déjà complétées.",
							content:
								"Il suffit de cliquer sur une étape complétée pour revoir les paramètres et revenir à l'étape actuelle pour continuer là où vous vous êtes arrêté.",
						},
					},
					aiTutorialModal: {
						step1: {
							title: "Cliquez sur l'<highlight>Assistant IA</highlight>",
							description:
								"Ouvrez l'Assistant pour commencer la création automatique de vos points de vente.",
						},
						step2: {
							title:
								"Décrivez les noms et quantités des <highlight>points de vente</highlight>",
							description:
								"Indiquez les noms et les quantités des emplacements où se dérouleront les ventes avec les machines Zig. (Ex. : 1 Bar Principal, 2 Pistes Premium, 1 Espace Cuisine)",
							note: "Soignez vos descriptions !",
						},
						step3: {
							title: "Confirmez et <highlight>générez les points de vente</highlight>",
							description:
								"Consultez le résumé que l'IA vous montrera et cliquez sur 'Générer les points de vente' pour les créer automatiquement.",
						},
						buttons: {
							understand: "Compris",
						},
					},
					aiAssistant: {
						panelTitle: "Assistant IA de Zig",
						triggerBubbleTitle: "Je suis votre Assistant IA de Zig.",
						triggerBubbleSubtitle: "Je vous aide à créer vos points de vente",
						inputPlaceholder: "Décrivez les points de vente ou posez une question",
						generateButton: "Générer les points de vente",
						initialMessage:
							"👋 Bonjour ! Je suis votre Assistant IA.\nJe suis ici pour vous aider à créer les points de vente de votre opération.\n\n📋 Dites-moi simplement ce dont vous avez besoin (noms et quantités).\nJe passe tout en revue avec vous et, avec votre confirmation, je génère tout automatiquement.\n\n💬 Commençons ? Quels points de vente souhaitez-vous créer ?",
						summaryIntro: "Parfait ! Voici le résumé de ce que vous avez décrit :",
						summaryConfirmation:
							"Si tout est correct, cliquez ci-dessous pour générer les points de vente.",
						loadingMessage: "Création en cours...",
						successMessage:
							"🎉 Parfait ! Les points de vente ont été créés avec succès !",
						successFollowUp:
							"Si vous souhaitez ajouter d'autres points de vente, envoyez-moi à nouveau les noms et quantités.",
						onlyCreateError:
							"😅 Désolé, je ne peux que créer de nouveaux points de vente ici. Si vous devez modifier ou supprimer un existant, vous pouvez le faire directement à l'écran.",
					},
				},
				sectors: {
					subStepTitle: "Secteurs",
					title:
						"Souhaitez-vous organiser vos points de vente en <highlight>secteurs</highlight> ?",
					subtitle:
						"Définissez si vous préférez structurer vos points de vente en secteurs ou les conserver séparément.",
					options: {
						withoutSectors: {
							title: "Conserver les points de vente indépendants (sans secteurs)",
							subtitle:
								"Les points de vente resteront indépendants, sans regroupement par secteur.",
						},
						withSectors: {
							title: "Organiser les points de vente par secteurs",
							subtitle:
								"Les points de vente seront regroupés dans les secteurs que vous définirez.",
						},
					},
					placeholder: {
						message: "La fonctionnalité des secteurs sera bientôt implémentée.",
					},
					creation: {
						title: "Regroupez tous les points de vente en secteurs",
						subtitle: "Tous les points de vente devront appartenir à un secteur.",
						createButton: "Créer un nouveau Secteur",
						emptyTitle: "Rien ici pour le moment",
						emptySubtitle: "Regroupez les points de vente en secteurs",
						unlinkedCount: "{{count}} Points de vente à regrouper",
						tour: {
							title: "Créez le premier secteur",
							content:
								"Cliquez sur le bouton 'Créer un nouveau secteur' pour commencer à organiser vos points de vente.",
							understood: "Compris",
						},
						deleteConfirmTitle: "Supprimer le secteur ?",
						deleteConfirmSubtitle:
							"Ce secteur sera supprimé. Ses points de vente pourront être affectés à un autre secteur.",
					},
					creationDrawer: {
						createTitle: "Créer un nouveau Secteur",
						editTitle: "Modifier le Secteur",
						nameLabel: "Nom",
						namePlaceholder: "Saisissez le nom du secteur",
						nameRequired: "Champ obligatoire",
						pointsOfSaleLabel: "Points de vente du Secteur",
						pointsOfSalePlaceholder: "Sélectionnez les points de vente",
						pointsOfSaleRequired: "Champ obligatoire",
						createButton: "Créer un nouveau Secteur",
						saveButton: "Enregistrer",
					},
				},
				review: {
					subStepTitle: "Révision",
					title: "Étape 2 terminée ! <highlight>Points de vente</highlight> configurés !",
					subtitle:
						"Les points de vente que vous avez créés sont prêts pour les produits et les employés.",
					reviewTitle: "Révisez les réponses",
					reviewSubtitle: "Vous pourrez les modifier maintenant ou à la fin du flux.",
					reviewAlertTitle: "Révisez cette étape calmement.",
					reviewAlert:
						"En continuant, ces configurations ne pourront plus être modifiées ici et devront être ajustées directement dans les modules du Dashboard.",
					editStep: "Modifier",
					editPointsOfSale: "Points de vente",
					editSectors: "Secteurs",
					pointsOfSaleLabel: "Points de vente",
					notInformed: "Non renseigné",
				},
				pdvCreateNewPdvDrawer: {
					title: "Ce nom de point de vente existe déjà",
					subtitle:
						"Un point de vente avec ce nom existe déjà. Pour continuer, choisissez un nom différent pour éviter la duplication.",
					newPdvDrawerTitle: "Nom du point de vente",
					createButton: "Créer un point de vente",
					nameRequired: "Le nom du point de vente est obligatoire",
				},
			},
			menu: {
				title: "Menu",
				subtitle: "Configurez les produits",
				organization: {
					title:
						"Les <highlight>ventes seront-elles différentes</highlight> selon le point de vente ?",
					subtitle:
						"Définissez si les points de vente partageront les mêmes produits et prix ou s'il y aura des différences entre eux.",
					subStepTitle: "Organisation",
					yes: {
						title: "OUI",
						subtitle: "Chaque point de vente aura ses propres produits et prix.",
						example:
							"Exemple : Chaque point de vente a ses propres ventes avec des produits différents.",
					},
					no: {
						title: "NON",
						subtitle:
							"Tous les points de vente auront les mêmes produits et les mêmes prix.",
						example:
							"Exemple : Dans n'importe quel point de vente, les options de produits sont identiques.",
					},
					changeFormatModal: {
						title: "Voulez-vous modifier le format de vente des points de vente ?",
						description:
							"Vous modifiez la façon dont les produits sont vendus entre les points de vente. Cette modification peut impacter les configurations actuelles et peut nécessiter des ajustements selon le nouveau choix. Voulez-vous continuer quand même ?",
						cancelButton: "Annuler",
						confirmButton: "Oui, modifier le format de vente",
					},
				},
				buildMenus: {
					title: "Créez votre <highlight>menu</highlight>",
					subtitle:
						"Importez des produits avec des photos, des feuilles de calcul ou des PDFs.",
					subStepTitle: "Créer les menus",
					templateFileName: "modele_produits_menu",
					import: {
						success: "{{count}} produit(s) importé(s) depuis la feuille de calcul.",
						invalidRowsError:
							"Importation impossible : corrigez les champs invalides dans la feuille de calcul ({{fields}}) et réimportez-la.",
						emptyError: "Aucun produit trouvé dans la feuille de calcul.",
						defaultCategory: "Sans catégorie",
						loadingText: "Importation de la feuille de calcul...",
					},
					buttons: {
						templateSpreadsheet: "Feuille de calcul modèle",
						createCategory: "Créer une catégorie",
						addManually: "Ajouter manuellement",
					},
					tour: {
						locale: {
							back: "Retour",
							next: "Suivant",
							close: "Compris",
						},
						steps: {
							upload: {
								title: "Commencez par télécharger un fichier avec vos produits.",
								content:
									"Vous pouvez ajouter une photo, une feuille de calcul ou un PDF avec les produits que vous souhaitez inclure dans ce menu. L'IA lira le fichier et enregistrera automatiquement les articles pour vous.",
							},
							manual: {
								title: "Ou, si vous préférez, ajoutez les produits manuellement.",
								content:
									"Si vous le souhaitez, vous pouvez créer des catégories et ajouter des produits manuellement sans utiliser de fichier.",
							},
						},
					},
					addProductDrawer: {
						title: "Ajouter un produit",
						titleEdit: "Modifier le produit",
						labels: {
							name: "Nom du produit",
							value: "Prix",
							category: "Catégorie du produit",
						},
						placeholders: {
							name: "Entrez le nom du produit ici",
							value: "00,00",
							category: "Sélectionner",
						},
						errors: {
							nameRequired: "Le nom du produit est obligatoire",
							nameDuplicated: "Un produit avec ce nom existe déjà",
							valueRequired: "Le prix du produit est obligatoire",
							categoryRequired: "La catégorie est obligatoire",
						},
						buttons: {
							cancel: "Annuler",
							add: "Ajouter le produit",
							save: "Enregistrer",
						},
						createCategoryOption: "Créer une catégorie",
					},
					createCategoryModal: {
						title: "Créer une catégorie",
						label: "Nom de la catégorie",
						placeholder: "Entrez le nom de la catégorie ici",
						errors: {
							nameRequired: "Le nom de la catégorie est obligatoire",
							nameDuplicated: "Une catégorie avec ce nom existe déjà",
						},
						buttons: {
							cancel: "Annuler",
							create: "Créer la catégorie",
						},
					},
					removeCategory: {
						title: "Supprimer la catégorie",
						description:
							"En supprimant cette catégorie, tous les produits qui y sont liés seront également supprimés. Voulez-vous continuer ?",
						confirmButton: "Supprimer la catégorie",
					},
					removeProduct: {
						title: "Supprimer le produit",
						description:
							"Ce produit sera supprimé du menu et ne pourra plus être vendu aux points de vente. Voulez-vous confirmer la suppression ?",
						confirmButton: "Supprimer le produit",
					},
				},
				linkProducts: {
					title: "Liez les <highlight>produits</highlight> aux points de vente",
					subtitle:
						"Les menus et produits seront vendus au point de vente auquel ils sont liés",
					subStepTitle: "Lier les produits",
					noProductsLinked: "Aucun produit lié !",
					productsCount: "{{count}} produits",
					productsCount_one: "{{count}} produit",
					linkProductsButton: "Lier les produits",
					viewProductsLink: "Voir les produits",
					incompleteModal: {
						title: "Certains points de vente sont incomplets",
						description:
							"Certains points de vente n'ont pas de menus ni de produits liés. Vous pouvez lier maintenant ou continuer et modifier plus tard.",
						continueButton: "Continuer et modifier plus tard",
						editButton: "Modifier maintenant",
					},
					tour: {
						locale: {
							close: "Compris",
						},
						step: {
							title: "Définissez ce que chaque point de vente vendra.",
							content:
								"Sélectionnez les menus que ce point aura. Vous pouvez également désactiver/activer des produits spécifiques, en ne laissant que ce qui sera vendu là-bas.",
						},
					},
					drawer: {
						editTitle: "Sélectionnez les menus pour ce point de vente",
						editSubtitle:
							"Les produits de ces menus seront liés à ce point. Vous pouvez désactiver des produits spécifiques si vous le souhaitez.",
						viewTitle: "Produits liés",
						viewSubtitle:
							"Vérifiez les produits de ce point de vente et modifiez les liens si vous le souhaitez.",
						selectAllLabel: "Sélectionner tous les produits de {{categoryName}}",
						labels: {
							menus: "Menus",
							searchProduct: "Rechercher par produit",
							searchCategory: "Rechercher par catégorie de produit",
						},
						placeholders: {
							menus: "Sélectionner",
						},
						buttons: {
							cancel: "Annuler",
							link: "Lier les produits",
							edit: "Modifier",
							close: "Fermer",
						},
						empty: {
							title: "Rien ici pour l'instant",
							subtitle: "Liez les menus que ce point de vente aura.",
						},
						noResultsFound: {
							title: "Aucun résultat trouvé",
							subtitle: "Essayez de rechercher un autre terme.",
						},
					},
				},
				review: {
					title: "Vérifiez les <highlight>paramètres du menu</highlight>",
					subtitle:
						"Vérifiez que toutes les informations sont correctes avant de continuer.",
					subStepTitle: "Révision",
					pendingTitle: "Étape 3 : <highlight>paramètres en attente</highlight>",
					pendingSubtitle: "Vous avez décidé de configurer cette étape plus tard.",
					reviewTitle: "Vérifiez vos réponses",
					reviewSubtitle:
						"Vous pourrez les modifier maintenant, avant de terminer l'étape.",
					editStep: "Modifier l'étape",
				},
			},
			employees: {
				title: "Employés",
				subtitle: "Configurez l'équipe de l'opération",
				rolesAndPermissions: {
					title:
						"Qui travaillera avec les <highlight>machines à jetons</highlight> lors de l'opération ?",
					subtitle:
						"Définissez les postes et les quantités de ceux qui vendront des jetons avec les machines lors de l'opération.",
					subStepTitle: "Postes et permissions",
					header: "Postes et permissions",
					totalEmployees: "Total des employés :",
					createRole: "Créer un nouveau poste",
					roleDrawer: {
						title: "Créer un poste",
						roleNameLabel: "Nom du poste",
						selectStandardRole: "Sélectionnez un poste standard existant",
						selectStandardRolePlaceholder: "Sélectionnez un poste",
						defaultPermissionsTab: "Permissions standard",
						otherPermissionsTab: "Autres permissions",
						createButton: "Créer le poste",
						duplicateNameError: "Un poste avec ce nom existe déjà",
						editTitle: "Modifier le poste",
						duplicateTitle: "Dupliquer le poste",
						viewTitle: "Voir les permissions",
						editRoleButton: "Modifier le poste",
						confirmButton: "Confirmer",
						searchPermissionsPlaceholder: "Rechercher une permission",
						confirmClose: {
							title: "Abandonner les modifications ?",
							subtitle:
								"Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer sans enregistrer ?",
							confirm: "Abandonner",
							cancel: "Continuer la modification",
						},
					},
					confirmDelete: {
						title: "Supprimer le poste avec des employés associés",
						subtitle:
							"Ce poste a {{count}} employé(s) associé(s). Voulez-vous quand même le supprimer ?",
						confirm: "Supprimer le poste",
						cancel: "Annuler",
					},
					tour: {
						locale: {
							back: "Retour",
							next: "Suivant",
							close: "Compris",
						},
						step1: {
							title: "Ces postes sont des suggestions pour votre opération.",
							content:
								"Vous pouvez les modifier ou les supprimer selon vos besoins. Si vous ne souhaitez pas qu'un poste existe dans l'opération, supprimez-le. Sinon, il sera créé même si la quantité est nulle.",
						},
						step2: {
							title: "Définissez combien de personnes occuperont chaque poste",
							content:
								"Utilisez le compteur pour indiquer combien de personnes travailleront dans chaque fonction. Seuls les postes avec une quantité définie auront des identifiants générés automatiquement.",
						},
						step3: {
							title: "Créez des postes personnalisés",
							content:
								"Si vous avez besoin d'un poste différent de ceux suggérés, cliquez sur Créer un nouveau poste pour ajouter des fonctions spécifiques et définir des permissions personnalisées.",
						},
					},
				},
				linkEmployees: {
					title: "Associer des employés",
					subtitle: "Associez les employés à chaque point de vente.",
					subStepTitle: "Associer des employés",
					tour: {
						locale: {
							back: "Retour",
							next: "Suivant",
							close: "Compris",
						},
						step1: {
							title: "Associez les employés aux points de vente",
							content:
								"Les employés doivent être associés aux points de vente pour utiliser les terminaux et enregistrer les ventes. Vous pouvez définir si tous les employés du même poste travailleront aux mêmes points de vente ou si vous souhaitez les répartir individuellement.",
						},
						step2: {
							title: "Distribuez manuellement, si vous préférez",
							content:
								"Activez l'option Distribuer manuellement pour définir où chaque employé travaillera. Ainsi, vous pourrez choisir à quels points de vente chaque employé aura accès et visualiser cela individuellement.",
						},
					},
				},
				review: {
					title: "<highlight>Employés et postes</highlight> configurés !",
					subtitle: "Les employés et postes de l'opération sont déjà configurés.",
					subStepTitle: "Révision",
					pendingTitle: "Étape 4 : <highlight>paramètres en attente</highlight>",
					pendingSubtitle: "Vous avez décidé de configurer cette étape plus tard.",
					reviewTitle: "Vérifiez vos réponses",
					reviewSubtitle:
						"Vous pouvez les modifier maintenant, avant de terminer l'étape.",
					editStep: "Modifier l'étape",
					reviewAlertTitle: "Révisez attentivement cette étape.",
					reviewAlert:
						"Une fois que vous avancez, ces paramètres ne pourront plus être modifiés ici et devront être ajustés directement dans les modules du Dashboard.",
					notConfigured: "Étape non configurée",
					pendingEmptySubtitle:
						"Vous n'avez pas encore configuré les employés de cette opération.",
				},
				editEmployee: {
					title: "Modifier l'employé",
					nameLabel: "Nom",
					loginLabel: "Identifiant",
					passwordLabel: "Mot de passe",
					passwordMinLength: "Le mot de passe doit contenir au moins 3 caractères",
					loginNoSpaces: "L'identifiant ne peut pas contenir d'espaces",
					loginLowercase: "L'identifiant doit être en minuscules",
					loginDuplicated: "Cet identifiant est déjà utilisé par un autre employé",
					pointsOfSaleLabel: "Points de vente associés",
					pointsOfSalePlaceholder: "Sélectionnez les points de vente",
					saveButton: "Enregistrer",
					confirmClose: {
						title: "Abandonner les modifications ?",
						subtitle:
							"Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer sans enregistrer ?",
						confirm: "Abandonner",
						cancel: "Continuer la modification",
					},
				},
			},
		},
		operationTypes: {
			token: {
				label: "Jeton",
				description: "Le client échange un jeton contre un produit",
			},
			cashlessPrepaid: {
				label: "Cashless (prépaié)",
				description: "Le client charge du crédit sur une carte",
			},
			cashlessPostpaid: {
				label: "Cashless (postpayé)",
				description: "Le client paie sur une carte après consommation",
			},
			directSale: {
				label: "Vente directe au bar",
				description: "Le client paie le produit directement",
			},
			tables: {
				label: "Tables",
				description: "Le client passe commande auprès des serveurs",
			},
		},
		summary: {
			title: "Résumé de la configuration de <placeName>{{placeName}}</placeName> !",
			subtitle:
				"Modifiez les réponses, revenez aux étapes ou accédez aux paramètres avancés à tout moment.",
			editStep: "Modifier l'étape",
			operationType: "Type d'opération",
			functionalities: "Fonctionnalités",
			viewFunctionalities: "Voir les fonctionnalités",
			advancedConfigurations: "Paramètres avancés des fonctionnalités",
			notInformed: "Non renseigné",
			selectedCount: "{{count}} sélectionné(s)",
			pendingAction: "Action en attente",
			loading: "Chargement des paramètres...",
			placeIdNotFound: "ID de lieu non trouvé",
			errorLoading: "Erreur lors du chargement des données",
			menuContent: {
				manageLink: "Paramètres avancés du menu",
				empty: {
					title: "Rien ici pour le moment",
					subTitle: "Configurez cette étape pour voir le résumé ici.",
				},
				advancedConfig: "Configuration avancée",
			},
			employeesContent: {
				manageLink: "Paramètres avancés des équipes et des rôles",
			},
			stepEmpty: {
				title: "Rien ici pour le moment",
				subTitle:
					"L'assistant de configuration n'est plus disponible, mais vous pouvez terminer cette configuration depuis le Dashboard.",
				buttonLabel: "Configuration avancée",
			},
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Modifier",
				remove: "Supprimer",
				ariaLabel: "Menu d'options",
			},
			buttons: {
				cancel: "Annuler",
				save: "Enregistrer",
			},
		},
		productCard: {
			menu: {
				edit: "Modifier",
				remove: "Supprimer",
				ariaLabel: "Menu d'options",
			},
		},
		positionCard: {
			menu: {
				viewPermissions: "Voir les permissions",
				edit: "Modifier",
				duplicate: "Dupliquer",
				remove: "Supprimer",
				ariaLabel: "Menu d'options",
			},
			decrementLabel: "Diminuer la quantité",
			incrementLabel: "Augmenter la quantité",
		},
		menuCard: {
			productsCount: "{{count}} produits",
		},
		empty: {
			title: "Aucune donnée trouvée",
			description: "Il n'y a pas de données à afficher.",
			button: "Ajouter un nouvel élément",
		},
		attachmentsFile: {
			loadingText: "Veuillez patienter pendant l'envoi du fichier...",
			dragText: "Glissez et déposez le fichier",
			clickText: "ou cliquez pour sélectionner",
			fileTypeText: "Type de fichier {{fileType}} jusqu'à {{fileSize}}.",
			maxSizeExceeded: "La taille du fichier dépasse la limite autorisée.",
		},
		modalSelectImage: {
			productImage: "Modifier l'image",
			setTagInput: "rechercher le produit à l'aide de mots-clés",
			confirm: "Confirmer",
			notInformed: "Nom non renseigné",
			selectFrom: "Sélectionnez une image de votre ",
			computer: "ordinateur",
			addImage: "Ajouter une image",
			typeOfFile: "Type de fichier .jpg, .jpeg, .png jusqu'à 5MB",
			errorCreatingImageUrl: "Erreur lors de la création de l'URL de l'image",
		},
		employeePdvLink: {
			manualDistribution: "Distribuer manuellement",
			description:
				"Choisissez pour quels points de vente tous les <strong>{{count}} {{roleName}}</strong> vont travailler",
			selectedCount: "{{count}} Sélectionnés",
			selectPointsOfSale: "Sélectionnez les points de vente",
			noEmployees: "Aucun employé créé pour ce poste.",
			noEmployeesMessage:
				"Définissez le nombre de personnes dans ce poste pour activer la distribution par point de vente.",
		},
		employeeRoleTable: {
			columnOperator: "OPÉRATEUR",
			columnLogin: "LOGIN",
			columnPassword: "MOT DE PASSE",
			columnPdv: "POINTS DE VENTE LIÉS",
			linkedTo: "Liés à",
			employeesCount: "{{count}} employés",
			viewPermissions: "Voir les permissions",
			notInformed: "Non renseigné",
			noEmployees: "Aucun employé pour l'instant",
		},
		menuHeader: {
			linkedTo: "Lié à :",
			noLinkedPdv: "Aucun point de vente lié",
			noLinkedMenu: "Aucun menu lié",
			notConfigured: "Non configuré",
			productsCount: "{{count}} PRODUITS",
		},
	},
};
